webpackJsonp([4],{

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(343);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69ffaad6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(361);
function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69ffaad6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
/* harmony export (immutable) */ __webpack_exports__["b"] = labelCase;
/* harmony export (immutable) */ __webpack_exports__["c"] = lowerCase;
/* unused harmony export upperCase */
/* unused harmony export unCamelCase */
/* unused harmony export properCase */
/* unused harmony export removeNonWord */
/* harmony export (immutable) */ __webpack_exports__["d"] = pad;
function capitalize(value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function labelCase(str) {
  str = str.replace(/_/g, ' ');
  return capitalize(str);
}

function lowerCase(str) {
  return str.toLowerCase();
}

function upperCase(str) {
  return str.toUpperCase();
}

function unCamelCase(str) {
  str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
  str = str.toLowerCase();
  return str;
}

function properCase(str) {
  return lowerCase(str).replace(/^\w|\s\w/g, upperCase);
}

function removeNonWord(str) {
  return str.replace(/[^0-9a-zA-Z\xC0-\xFF -]/g, '');
}

function pad(num, size) {
  var s = num + '';
  while (s.length < size) {
    s = s + '0';
  }return s;
}

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_local_storage__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters_string_js__ = __webpack_require__(210);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  filters: {
    lowerCase: __WEBPACK_IMPORTED_MODULE_2__filters_string_js__["c" /* lowerCase */]
  },
  data: function data(router) {
    return {
      activar: true,
      info: '',
      section: 'Login',
      loading: false,
      form: {
        identifier: null,
        password: null
      },
      response: ''
    };
  },
  mounted: function mounted() {
    this.$store.commit('CLEAR_API_DATA', '*');
  },

  methods: {
    checkCreds: function checkCreds() {
      var vm = this;
      if (!vm.loading) {
        vm.toggleLoading();
        this.form.identifier = this.$options.filters.lowerCase(this.form.identifier);
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].login(this.form).then(function (data) {
          vm.info = 'Cargando roles, un momento por favor...';
          __WEBPACK_IMPORTED_MODULE_1__core_local_storage__["a" /* default */].setToken(data.jwt);
          __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getRoles().then(function () {
            vm.info = '';
            if (!vm.$store.state.apiData.roles[data.user.role._id]) {
              vm.response = 'No esta autorizado para ingresar.';
              __WEBPACK_IMPORTED_MODULE_1__core_local_storage__["a" /* default */].removeToken();
            } else {
              if (data.user.blocked) {
                vm.response = 'No esta autorizado para ingresar.';
                __WEBPACK_IMPORTED_MODULE_1__core_local_storage__["a" /* default */].removeToken();
              } else {
                var userData = data.user;
                // userData.proyectos = ['5b3e50f91f3898503bc90ef0', '5b3e52bff46de976b5c46205', '5b451d9236c61a12139ecc66']
                // userData.proyectos_ids = _.map(userData.proyectos, 'id')
                __WEBPACK_IMPORTED_MODULE_1__core_local_storage__["a" /* default */].setUser(userData);
                vm.$store.commit('SET_USER', userData);
                vm.$router.push({ name: 'dashboard' });
              }
            }

            vm.toggleLoading();
          }, function (error) {
            __WEBPACK_IMPORTED_MODULE_1__core_local_storage__["a" /* default */].removeToken();
            vm.info = '';
            vm.response = error.message;
            vm.toggleLoading();
          });
        }).catch(function () {
          vm.response = 'Usuario/Password incorrectos. Por favor volve a intentarlo.';
          __WEBPACK_IMPORTED_MODULE_1__core_local_storage__["a" /* default */].removeToken();
          vm.toggleLoading();
        });
      }
    },
    toggleLoading: function toggleLoading() {
      this.loading = !this.loading;
      this.$store.commit('TOGGLE_LOADING');
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    minimizar: function minimizar(input) {
      this.form.identifier = this.$options.filters.lowerCase(input);
    }
  }
});

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(360);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(198)("ba420988", content, true, {});

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(197)(true);
// imports


// module
exports.push([module.i, "#login{max-width:500px;margin-left:auto;margin-right:auto}.text-error{text-align:center;color:#d9534f;font-size:10px;margin-top:10px}.container-table,body,html{height:100%;background-color:#282b30!important}.container-table{display:table;color:#fff}.vertical-center-row{display:table-cell;vertical-align:middle}.vertical-20p{padding-top:20%}.vertical-10p{padding-top:10%}.vertical-5p{padding-top:5%}.logo-login{padding:3em;max-width:460px}#login .input-group{padding-bottom:2em;height:4em;width:100%}#login .input-group span.input-group-addon{width:2em;height:4em}@media (max-width:1241px){#login .input-group input{height:4em}}@media (min-width:1242px){#login .input-group input{height:6em}}.input-group-addon i{height:15px;width:15px}.loading{border:2px solid #f3f3f3;border-top:2px solid #3498db;border-radius:50%;width:18px;height:18px;-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite;float:right;margin-left:9px;margin-top:4px}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["D:/laragon/www/sima/simaapp-web/src/components/Login.vue"],"names":[],"mappings":"AACA,OACI,gBAAiB,AACjB,iBAAkB,AAClB,iBAAmB,CACtB,AACD,YACE,kBAAmB,AACnB,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,2BAGE,YAAa,AACb,kCAAqC,CACtC,AACD,iBACE,cAAe,AACf,UAAa,CACd,AACD,qBACE,mBAAoB,AACpB,qBAAuB,CACxB,AACD,cACE,eAAiB,CAClB,AACD,cACE,eAAiB,CAClB,AACD,aACE,cAAgB,CACjB,AACD,YACE,YAAa,AACb,eAAiB,CAClB,AACD,oBACE,mBAAoB,AACpB,WAAY,AACZ,UAAY,CACb,AACD,2CACE,UAAW,AACX,UAAY,CACb,AACD,0BACA,0BACI,UAAY,CACf,CACA,AACD,0BACA,0BACI,UAAY,CACf,CACA,AACD,qBACE,YAAa,AACb,UAAY,CACb,AACD,SACI,yBAA0B,AAC1B,6BAA8B,AAC9B,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,0CAA2C,AACnC,kCAAmC,AAC3C,YAAa,AACb,gBAAiB,AACjB,cAAgB,CACnB,AACD,wBACA,GAAK,+BAAgC,AAAC,sBAAwB,CAC7D,AACD,GAAO,gCAAkC,AAAC,uBAA0B,CACnE,CACA,AACD,gBACA,GAAK,+BAAgC,AAAC,sBAAwB,CAC7D,AACD,GAAO,gCAAkC,AAAC,uBAA0B,CACnE,CACA","file":"Login.vue","sourcesContent":["\n#login {\r\n    max-width: 500px;\r\n    margin-left: auto;\r\n    margin-right: auto;\n}\n.text-error{\r\n  text-align: center;\r\n  color: #d9534f;\r\n  font-size: 10px;\r\n  margin-top: 10px;\n}\nhtml,\r\nbody,\r\n.container-table {\r\n  height: 100%;\r\n  background-color: #282b30 !important;\n}\n.container-table {\r\n  display: table;\r\n  color: white;\n}\n.vertical-center-row {\r\n  display: table-cell;\r\n  vertical-align: middle;\n}\n.vertical-20p {\r\n  padding-top: 20%;\n}\n.vertical-10p {\r\n  padding-top: 10%;\n}\n.vertical-5p {\r\n  padding-top: 5%;\n}\n.logo-login {\r\n  padding: 3em;\r\n  max-width: 460px;\n}\n#login .input-group {\r\n  padding-bottom: 2em;\r\n  height: 4em;\r\n  width: 100%;\n}\n#login .input-group span.input-group-addon {\r\n  width: 2em;\r\n  height: 4em;\n}\n@media (max-width: 1241px) {\n#login .input-group input {\r\n    height: 4em;\n}\n}\n@media (min-width: 1242px) {\n#login .input-group input {\r\n    height: 6em;\n}\n}\n.input-group-addon i {\r\n  height: 15px;\r\n  width: 15px;\n}\n.loading {\r\n    border: 2px solid #f3f3f3;\r\n    border-top: 2px solid #3498db;\r\n    border-radius: 50%;\r\n    width: 18px;\r\n    height: 18px;\r\n    -webkit-animation: spin 2s linear infinite;\r\n            animation: spin 2s linear infinite;\r\n    float: right;\r\n    margin-left: 9px;\r\n    margin-top: 4px;\n}\n@-webkit-keyframes spin {\n0% { -webkit-transform: rotate(0deg); transform: rotate(0deg);\n}\n100% { -webkit-transform: rotate(360deg); transform: rotate(360deg);\n}\n}\n@keyframes spin {\n0% { -webkit-transform: rotate(0deg); transform: rotate(0deg);\n}\n100% { -webkit-transform: rotate(360deg); transform: rotate(360deg);\n}\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"login"}},[_c('img',{staticClass:"center-block logo-login",attrs:{"src":"/static/img/logo_sima_100_full.png"}}),_vm._v(" "),_c('div',{staticClass:"text-center col-sm-12"},[(_vm.info)?_c('div',{staticClass:"text-error"},[_c('p',{staticClass:"vertical-5p lead"},[_vm._v(_vm._s(_vm.info))])]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.checkCreds($event)}}},[_c('div',{staticClass:"input-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.identifier),expression:"form.identifier"}],staticClass:"form-control",attrs:{"autocapitalize":"off","name":"username","placeholder":"Usuario","type":"text"},domProps:{"value":(_vm.form.identifier)},on:{"blur":function($event){_vm.minimizar(_vm.form.identifier)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "identifier", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"form-control",attrs:{"name":"password","placeholder":"Password","type":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-lg",attrs:{"type":"submit","disabled":!_vm.activar}},[_vm._v("\n          Entrar \n          "),(_vm.loading)?_c('div',{staticClass:"loading"}):_vm._e()])]),_vm._v(" "),(_vm.response)?_c('div',{staticClass:"text-error"},[_c('p',{staticClass:"vertical-5p lead"},[_vm._v(_vm._s(_vm.response))])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-lock"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.0fb64c7b1ff686a7a88c.js